
import { defineComponent } from 'vue';
import Input from './Input.vue';
import CheckmarkIcon from './CheckmarkIcon.vue';
import EyeIcon from './EyeIcon.vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'PasswordInput',
  components: {
    Input,
    CheckmarkIcon,
    EyeIcon
  },
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    autocomplete: {
      type: String
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    isValid: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    validatePassword: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'update:isValid'],
  data () {
    return {
      showPasswordPolicy: false,
      showPassword: false,
      focused: false
    };
  },
  watch: {
    isValidPassword (isValid: boolean): void {
      if (this.validatePassword) {
        this.$emit('update:isValid', isValid);
      }
    }
  },
  methods: {
    onTogglePassword () {
      this.showPassword = !this.showPassword;
    },
    onInputFocus () {
      this.focused = true;
      this.showPasswordPolicy = true;
    },
    onInputBlur () {
      this.focused = false;
      if (this.isValidPassword) {
        this.showPasswordPolicy = false;
      }
    },
    passwordRequirementsList () {
      return [
        {
          text: this.$t('message.password_policy_spaces'),
          validator: this.passwordMustNotStartOrEndWithSpaces
        },
        {
          text: this.$t('message.password_policy_length'),
          validator: this.passwordHasValidLenght
        },
        {
          text: this.$t('message.password_policy_lowercase'),
          validator: this.passwordHasLowercase
        },
        {
          text: this.$t('message.password_policy_uppercase'),
          validator: this.passwordHasUppercase
        },
        {
          text: this.$t('message.password_policy_number'),
          validator: this.passwordHasNumber
        },
        {
          text: this.$t('message.password_policy_special'),
          validator: this.passwordHasSpecialChar
        }
      ];
    }

  },
  computed: {
    ...mapGetters([
      'passwordPolicy'
    ]),
    isValidPassword (): boolean {
      return this.passwordMustNotStartOrEndWithSpaces &&
        this.passwordHasValidLenght &&
        this.passwordHasLowercase &&
        this.passwordHasUppercase &&
        this.passwordHasNumber &&
        this.passwordHasSpecialChar;
    },
    statusBarPercentage (): number {
      let percentage = 0;
      if (this.passwordMustNotStartOrEndWithSpaces) {
        percentage++;
      }
      if (this.passwordHasValidLenght) {
        percentage++;
      }
      if (this.passwordHasLowercase) {
        percentage++;
      }
      if (this.passwordHasUppercase) {
        percentage++;
      }
      if (this.passwordHasNumber) {
        percentage++;
      }
      if (this.passwordHasSpecialChar) {
        percentage++;
      }
      return percentage;
    },
    passwordMustNotStartOrEndWithSpaces (): boolean {
      return this.passwordPolicy.noStartingSpacesRgx.test(this.modelValue) &&
        this.passwordPolicy.noEndingSpacesRgx.test(this.modelValue);
    },
    passwordHasValidLenght (): boolean {
      return this.modelValue?.length >= this.passwordPolicy.length;
    },
    passwordHasLowercase (): boolean {
      return this.passwordPolicy.lowerCaseRgx.test(this.modelValue);
    },
    passwordHasUppercase (): boolean {
      return this.passwordPolicy.upperCaseRgx.test(this.modelValue);
    },
    passwordHasNumber (): boolean {
      return this.passwordPolicy.numberRgx.test(this.modelValue);
    },
    passwordHasSpecialChar (): boolean {
      return this.passwordPolicy.specialCharRgx.test(this.modelValue);
    }
  }
});
